import { Grid } from "@mui/material";
import { PlantAddressForm } from "./PlantAddressForm";
import { PlantCoordinatesForm } from "./PlantCoordinatesForm";
import { PlantFormProps } from "./PlantFormProps";
import { PlantGsdbForm } from "./PlantGsdbForm";
import { MdmFormProps } from "../../Forms/MdmFormProps";

export const PlantForm = ({ plant, disabledFields }: PlantFormProps & MdmFormProps) => {
  return (
    <Grid container columnSpacing={3}>
      <Grid item xs={12}>
        <PlantGsdbForm disabledFields={disabledFields} plant={plant} />
      </Grid>
      <Grid item xs={9}>
        <PlantAddressForm disabledFields={disabledFields} plant={plant} />
      </Grid>
      <Grid item xs={3}>
        <PlantCoordinatesForm disabledFields={disabledFields} plant={plant} />
      </Grid>
    </Grid>
  );
};
